/**
 * @file close-word.ts
 * @description Слово подтверждения закрытия сайта от поисковиков (phase19.16,
 * партия Р3в, v0.19.64; SB145): кнопка в окне активна только при точном
 * слове; регистр и пробелы по краям не важны. То же слово уходит серверу
 * в `confirm` — он проверяет его ещё раз.
 */

export const CLOSE_INDEXING_WORD = "закрыть";

/** Совпадает ли ввод со словом подтверждения. */
export function isCloseWord(text: string): boolean {
  return text.trim().toLowerCase() === CLOSE_INDEXING_WORD;
}
